<template>
	<svg viewBox="0 0 15.906 12">
		<path
			d="M18.067,8.308a.928.928,0,0,1-.287.687L8.954,17.681a1,1,0,0,1-1.4,0l-5.111-5.03a.964.964,0,0,1,0-1.373L3.844,9.9a1,1,0,0,1,1.4,0l3.017,2.98,6.732-6.636a1,1,0,0,1,1.4,0l1.4,1.374A.928.928,0,0,1,18.067,8.308Z"
			transform="translate(-2.161 -5.964)"
		/>
	</svg>
</template>
